interface CarModelData {
  name: string;
  imgSrc: string;
  price: string;
}

const data: Array<CarModelData> = [
  { name: "impreza", imgSrc: "assets/img/top/lineup-impreza.jpg", price: "2,299,000円（税込）～" },
  { name: "crosstrek", imgSrc: "assets/img/top/lineup-crosstrek.jpg", price: "2,662,000円（税込）～" },
  { name: "forester", imgSrc: "assets/img/top/lineup-forester.jpg", price: "3,069,000円（税込）～" },
  { name: "levorg", imgSrc: "assets/img/top/lineup-levorg.jpg", price: "3,102,000円（税込）～" },
  { name: "solterra", imgSrc: "assets/img/top/lineup-solterra.jpg", price: "5,940,000円（税込）～" },
  { name: "legacy_outback", imgSrc: "assets/img/top/lineup-legacy_outback.jpg", price: "4,257,000円（税込）～" },
  { name: "wrx_s4", imgSrc: "assets/img/top/lineup-wrx_s4.jpg", price: "4,004,000円（税込）～" },
  { name: "subaru_brz", imgSrc: "assets/img/top/lineup-subaru_brz.jpg", price: "3,300,000円（税込）～" },
  { name: "justy", imgSrc: "assets/img/top/lineup-justy.jpg", price: "1,974,600円（税込）～" },
  { name: "rex", imgSrc: "assets/img/top/lineup-rex.jpg", price: "1,820,000円（税込）～" },
  { name: "chiffon", imgSrc: "assets/img/top/lineup-chiffon.jpg", price: "1,386,000円（税込）～" },
  { name: "chiffon_custom", imgSrc: "assets/img/top/lineup-chiffon_custom.jpg", price: "1,804,000円（税込）～" },
  { name: "stella", imgSrc: "assets/img/top/lineup-stella.jpg", price: "1,201,200円（税込）～" },
  { name: "stella_custom", imgSrc: "assets/img/top/lineup-stella_custom.jpg", price: "1,518,000円（税込）～" },
  { name: "pleo_plus", imgSrc: "assets/img/top/lineup-pleo_plus.jpg", price: "970,200円（税込）～" },
  { name: "sambar_van", imgSrc: "assets/img/top/lineup-sambar_van.jpg", price: "1,045,000円（税込）～" },
  { name: "sambar_truck", imgSrc: "assets/img/top/lineup-sambar_truck.jpg", price: "968,000円（税込）～" },
  { name: "transcare", imgSrc: "carlineup/common/img/main/lineup-transcare.png", price: "5,080,000円（税込）～" },
  {
    name: "transcare-kei",
    imgSrc: "carlineup/common/img/main/lineup-transcare-kei.png",
    price: "1,819,000円（税込）～",
  },
  {
    name: "forester_sti_sport",
    imgSrc: "assets/img/top/lineup-forester_sti_sport.jpg",
    price: "3,069,000円（税込）～",
  },
  { name: "levorg_sti_sport", imgSrc: "assets/img/top/lineup-levorg_sti_sport.jpg", price: "3,762,000円（税込）～" },
  { name: "wrx_s4_sti_sport", imgSrc: "assets/img/top/lineup-wrx_s4_sti_sport.jpg", price: "4,444,000円（税込）～" },
];

export default data;
